export default "__VITE_ASSET__CXk4jVcI__"